import { Avatar, Card, CardHeader, CardSubtitle, CardTitle, Menu, MenuItem, MenuSelectEvent } from '@progress/kendo-react-layout'
import { ChatApi } from '../redux/api/ChatApi'
import IChatUser from '../types/IChatUser'
import OnlineIndicator from './OnlineIndicator';
import { Link } from 'react-router-dom';
import { useReduxDispatch } from '../redux/hooks';
import { ChatStarted, DisconnectUser } from '../redux/reducers/ChatSlice';
import { IChat } from '../types/IChat';

export const UserListItem = ({ user, onChatStarted }: { user: IChatUser, onChatStarted: (chat: IChat) => void }) => {
    const dispatch = useReduxDispatch();
    const { data: userProfile } = ChatApi.useGetProfileQuery();
    const [updateVisibility] = ChatApi.useUpdateUserVisibilityMutation();
    const [continueChat] = ChatApi.useContinueChatMutation();

    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    let initials = [...user.Name.matchAll(rgx)] || [];
    //console.log('initials', initials)
    let letters = (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();

    if (!userProfile)
        return <></>

    function moreOptionsClick(e: MenuSelectEvent) {
        e.syntheticEvent.stopPropagation();
        e.syntheticEvent.preventDefault();
        console.log('moreOptionsClick', e);
        if (e.item.data === 0) {
            continueStaffChat(e);
        }

        if (e.item.data === 1) {
            updateVisibility({ ID: 0, Contact_Id: user.Contact_Id, Visibility: 0 }).unwrap().then(() => {
                //Tell the Signal R backend this user was booted.
                console.log(user.Contact_Id + ' was booted from the chat')
                dispatch(DisconnectUser(user));
            });
        }
        //
    }

    function continueStaffChat(e) {

        console.log('continueStaffChat', userProfile.Id, user.Contact_Id)
        //Start chat with user.
        continueChat({ StaffContact_Id: userProfile.Id, EndUserContact_Id: user.Contact_Id } as IChat).unwrap().then((chat: IChat) => {
            console.log('chat continued...', chat);
            onChatStarted(chat);

            //Only do this once we post the first message to the user - that will POP the chat open and pin it
            //Tell the signal R server that a new chat may have started so the other staff gets notified.
            //dispatch(ChatStarted(chat));
        });
    }

    return (
        <Link to='#' onClick={continueStaffChat}>
            <Card orientation="horizontal" className='user-card'>
                <span title={user.Name} className='profile-wrapper'>
                    <OnlineIndicator Uid={user.UId} />
                    {!user.Profile_Image_Url || user.Profile_Image_Url?.indexOf('placeholder') > -1
                        ? <Avatar className='avatar' size='medium' type="text">
                            {letters}
                        </Avatar>
                        : <Avatar className='avatar' size='small' type="image">
                            <img
                                src={user.Profile_Image_Url}
                                alt={`profile image`}
                            />
                        </Avatar>
                    }
                </span>
                <div className="k-vbox">
                    <CardHeader>
                        <CardTitle>{user.Name}</CardTitle>
                        <CardSubtitle style={{ fontSize: '14px' }}>
                            {user.Team}
                        </CardSubtitle>
                    </CardHeader>
                </div>

                <div className='chat-user-menu'>
                    <Menu openOnClick={true} onSelect={moreOptionsClick} >
                        <MenuItem linkRender={() => { return <Link to='#' className='k-icon k-i-more-horizontal'></Link> }}  >
                            <MenuItem text='Chat' data={0} icon='comment' />
                            <MenuItem text='Disconnect User' data={1} icon='close-circle' />
                        </MenuItem>
                    </Menu>
                </div>
            </Card >
        </Link>
    )
}
